// extracted by mini-css-extract-plugin
module.exports = {"container":"AddMorePlaceholder_container__2Zw90","icon":"AddMorePlaceholder_icon__2GSZZ","label":"AddMorePlaceholder_label__XG293"};